import React from 'react';

export default class TicketStubOutline extends React.Component {
  static propTypes = {
    ovalColorClass: React.PropTypes.string,
    isBlue: React.PropTypes.bool,
    isGreen: React.PropTypes.bool
  };

  static defaultProps = {
    ovalColorClass: ''
  };

  getColorClass = () => {
    if (this.props.isBlue) return 'ticket_stub_outline--blue';
    if (this.props.isGreen) return 'ticket_stub_outline--green';

    return 'ticket_stub_outline';
  };

  render () {
    return (
      <div className={this.getColorClass() + ' ' + this.props.ovalColorClass} />
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/outline.js